
export const resolveDatePreset = preset => {
  const now = new Date();

  const startOfDay = date => {
    const d = new Date(date);
    return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), 0, 0, 0, 0));
  };

  const endOfDay = date => {
    const d = new Date(date);
    return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), 23, 59, 59, 999));
  };

  const addUtcDays = (date, days) => {
    const d = new Date(date);
    return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() + days));
  };

  switch (preset) {
    case "today": {
      return {
        fromDate: startOfDay(now).getTime(),
        toDate: now.getTime()
      };
    }
    case "yesterday": {
      const yesterday = addUtcDays(now, -1);
      return {
        fromDate: startOfDay(yesterday).getTime(),
        toDate: endOfDay(yesterday).getTime()
      };
    }
    case "lastWeek": {
      const day = now.getUTCDay(); // 0=Sun
      const daysToLastMonday = day === 0 ? 6 : day - 1 + 7;
      const lastMonday = addUtcDays(now, -daysToLastMonday);
      const lastSunday = addUtcDays(lastMonday, 6);
      return {
        fromDate: startOfDay(lastMonday).getTime(),
        toDate: endOfDay(lastSunday).getTime()
      };
    }
    case "thisMonth": {
      const firstOfMonth = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1));
      return {
        fromDate: startOfDay(firstOfMonth).getTime(),
        toDate: now.getTime()
      };
    }
    case "7d": {
      const from = new Date(now);
      from.setDate(from.getDate() - 7);
      return {
        fromDate: from.getTime(),
        toDate: now.getTime()
      };
    }
    case "30d": {
      const from = new Date(now);
      from.setDate(from.getDate() - 30);
      return {
        fromDate: from.getTime(),
        toDate: now.getTime()
      };
    }
    default: {
      const from = new Date(now);
      from.setDate(from.getDate() - 7);
      return {
        fromDate: from.getTime(),
        toDate: now.getTime()
      };
    }
  }
};
